import styled from 'styled-components';
import { H5 } from '@finect/tabular-core/Headings';
export var Title = styled(H5).withConfig({
  displayName: "Title",
  componentId: "sc-1stlg4g-0"
})(["display:block;font-size:20px;line-height:22px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
});